<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-form @submit.prevent="submit">
          <v-card class="elevation-2" :loading="sending ? 'primary' : false">
            <v-card-title>Sign In</v-card-title>
            
            <v-card-text>
              <v-text-field label="Email" type="email" v-model="email" :error-messages="emailErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-email' : undefined"/>
              <v-text-field label="Password" type="password" v-model="password" :error-messages="passwordErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-lock' : undefined"/>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>

              <v-btn color="primary" type="submit">Sign In</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'sign-in',
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(6) },
  },
  data: () => ({
    email: '',
    password: '',
    sending: false,
  }),
  computed: {
    emailErrors() {
      const errors = [];

      if(!this.$v.email.$dirty) {
        return errors;
      }

      !this.$v.email.email && errors.push('Must be a valid email');
      !this.$v.email.required && errors.push('Email is required');

      return errors;
    },
    passwordErrors() {
      const errors = [];

      if(!this.$v.password.$dirty) {
        return errors;
      }

      !this.$v.password.required && errors.push('Password is required');
      !this.$v.password.minLength && errors.push('Password must be at least 6 characters long');

      return errors;
    }
  },
  methods: {
    submit() {
      this.$v.$touch();

      if(!this.$v.$invalid) {
        this.signIn();
      }
    },
    signIn() {
      this.sending = true;
      
      this.$store.dispatch('signIn', {
        email: this.email,
        password: this.password
      })
      .then(() => {
        this.sending = false;

        this.$router.go(-1);
      })
      .catch(() => {
        this.sending = false;
      });
    }
  }
}
</script>